import { rhythmIds } from "./rhythm-ids";
import { SpecificRhythm } from "./rhythm-types";

const jhaptaalTheka: SpecificRhythm = {
    id: rhythmIds.jhaptaalTheka,
    displayName: "Jhaptaal Theka",
    beatsPerCycle: 10,
    bols: [
        ["Dhin", "Na", "Dhin", "Dhin", "Na"],
        ["Tin", "Na", "Dhin", "Dhin", "Na"],
    ],
};

const roopakTheka: SpecificRhythm = {
    id: rhythmIds.roopakTheka,
    displayName: "Roopak Theka",
    beatsPerCycle: 7,
    bols: [
        ["Tin", "Tin", "Na"],
        ["Dhin", "Na", "Dhin", "Na"],
    ],
};

const deepchandiTheka: SpecificRhythm = {
    id: rhythmIds.deepchandiTheka,
    displayName: "Deepchandi Theka",
    beatsPerCycle: 14,
    bols: [
        ["Dha", "Dhin", "-"],
        ["Dha", "Ge", "Tin", "-"],
        ["Ta", "Tin", "-"],
        ["Dha", "Ge", "Dhin", "-"],
    ],
};

const punjabiTheka: SpecificRhythm = {
    id: rhythmIds.punjabiTheka,
    displayName: "Punjabi Theka",
    beatsPerCycle: 16,
    bols: [
        ["Dha-", "-Dhin", "--", "Dha-"],
        ["Dha-", "-Dhin", "--", "Dha-"],
        ["Dha-", "-Tin", "--", "Ta-"],
        ["Ta-", "-Dhin", "--", "Dha-"],
    ],
};

export const rhythms: { [key: string]: SpecificRhythm } = {
    [rhythmIds.jhaptaalTheka]: jhaptaalTheka,
    [rhythmIds.roopakTheka]: roopakTheka,
    [rhythmIds.deepchandiTheka]: deepchandiTheka,
    [rhythmIds.punjabiTheka]: punjabiTheka,
};
